import React from 'react';
import { View, StyleSheet, ViewStyle, StyleProp } from 'react-native';

import { Text, Icon } from './';
import { TEXT, ANNOUNCEMENT } from '../constants/colors';

type Props = {
  message: string;
  style?: StyleProp<ViewStyle>;
};
export default function Announcement(props: Props) {
  let { message, style } = props;

  return (
    <View style={[styles.container, style]}>
      <Icon
        name="megaphone"
        size="medium"
        iconStyle={styles.icon}
        color={TEXT.blackOpacity}
      />
      <Text style={styles.message}>{message}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: ANNOUNCEMENT.background,
    borderRadius: 12,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 16,
    zIndex: -1,
  },
  icon: {
    marginLeft: 26,
  },
  message: {
    marginLeft: 18,
    color: TEXT.blackOpacity,
    fontSize: 14,
    lineHeight: 22,
    textAlign: 'left',
    paddingRight: 43,
  },
});
